// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".album__head[data-v-3c992ada]{position:fixed;top:0;left:0;width:100%;z-index:-1}.album__list[data-v-3c992ada]{margin-top:3.2rem}.album__bottom[data-v-3c992ada]{position:fixed;bottom:0;left:0;width:100%}", ""]);
// Exports
module.exports = exports;
